import { Card, Header } from '@breward/ui';
import { useTranslation } from 'react-i18next';
import { BeerGuidelines } from '../types';

interface ParametersCardProps {
    gl?: BeerGuidelines;
}

export const ParametersCard = ({ gl }: ParametersCardProps) => {
    const [t] = useTranslation();

    const renderValue = (min?: number | null, max?: number | null, unit: string = '') => {
        if (min === undefined || min === null) {
            if (max === undefined || max === null) {
                return '-';
            }
            return `${max}${unit}`;
        }
        if (max === undefined || max === null) {
            return `${min}${unit}`;
        }
        return `${min} - ${max}${unit}`;
    };

    const renderParameterCard = (icon: string, label: string, value: string, color: string) => (
        <div className={`rounded-xl bg-gradient-to-br ${color} p-4 text-white shadow-md flex flex-col justify-between h-20`}>
            <div className="flex justify-between items-center">
                <div className={`${icon} h-5 w-5 opacity-90`} />
                <span className="text-[10px] font-bold uppercase tracking-wider opacity-80">{label}</span>
            </div>
            <div className="text-base font-extrabold">{value}</div>
        </div>
    );

    return (
        <Card className="p-5">
            <div className="col-span-12 flex flex-col gap-4">
                <Header
                    variant="card"
                    title={t('Pages:ParticipantWeb.ShowStylePage.Parameters.title', 'Parametry stylu')}
                />
                <div className="grid grid-cols-2 gap-3 font-sans">
                    {renderParameterCard('icon-[ph--percent-bold]', 'ABV', renderValue(gl?.minAbv, gl?.maxAbv, '%'), 'from-blue-500 to-blue-600 dark:from-blue-600 dark:to-blue-700')}
                    {renderParameterCard('icon-[ph--leaf-bold]', 'IBU', renderValue(gl?.minIbu, gl?.maxIbu), 'from-emerald-500 to-emerald-600 dark:from-emerald-600 dark:to-emerald-700')}
                    {renderParameterCard('icon-[ph--palette-bold]', 'EBC', renderValue(gl?.minColor, gl?.maxColor), 'from-amber-500 to-amber-600 dark:from-amber-600 dark:to-amber-700')}
                    {renderParameterCard('icon-[ph--flask-bold]', 'OG', renderValue(gl?.minOriginalExtract, gl?.maxOriginalExtract, '°Plato'), 'from-purple-500 to-purple-600 dark:from-purple-600 dark:to-purple-700')}
                    <div className="col-span-2">
                        {renderParameterCard('icon-[ph--drop-bold]', 'FG', renderValue(gl?.minFinalExtract, gl?.maxFinalExtract, '°Plato'), 'from-cyan-500 to-cyan-600 dark:from-cyan-600 dark:to-cyan-700')}
                    </div>
                </div>
            </div>
        </Card>
    );
};
